export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13632.83fae4b7.jpg";